{
  "de": {
    "reminder": {
      "actions": {
        "cancel": "Abbrechen",
        "edit": "Bearbeiten",
        "hideReminders": "Erinnerungen ausblenden",
        "save": "Speichern",
        "showReminders": "Erinnerungen anzeigen"
      },
      "contactType": {
        "customer": "Kunde",
        "partner": "Partner"
      },
      "labels": {
        "after": "nach",
        "before": "vor",
        "click": "Klicken Sie hier, um eine Erinnerung festzulegen",
        "date": "am {date}",
        "dateAfterDueDate": "Nach der Fälligkeit",
        "dateAlreadyPassed": "Datum liegt bereits in der Vergangenheit",
        "decisionApprovedNotSent": "Die Entscheidung wurde getroffen. Erinnerungen, die sich noch in der Warteschlange befanden, wurden gelöscht.",
        "dueDate": "der Fälligkeit",
        "editTitle": "Erinnerungen bearbeiten",
        "here": "hier",
        "infoReminders": "Erinnerungen sind nur für Raten aktiv, für die eine Fälligkeit festgelegt ist.",
        "noReminderSet": "Keine Erinnerung festgelegt",
        "reminder": "Erinnerung",
        "reminders": "Erinnerungen",
        "remindersCustomer": "Erinnerungen für Ihren Kunden",
        "remindersPartners": "Erinnerungen für die Partner",
        "reminders_count": "{count} Erinnerung festgelegt | {count} Erinnerungen festgelegt",
        "sendOnDeadline": "Die Erinnerung wird am Fälligkeitstag gesendet",
        "sendReminder": "Erinnerung senden",
        "sent_at": "Erinnerung gesendet am {date}",
        "warningReminders": "Diese Aktion ersetzt alle 4 Erinnerungen. Jede hier leer gelassene Erinnerung wird für jede Entscheidung entfernt."
      },
      "toasts": {
        "update": "Erinnerung erfolgreich aktualisiert"
      }
    }
  }
}
